<template>
  <article class="reviews-card" :class="{ 'reviews-card--featured': featured }">
    <header class="reviews-card__header">
      <div class="reviews-card__avatar" aria-hidden="true">{{ initials }}</div>
      <div class="reviews-card__who">
        <p class="reviews-card__name">{{ item.name }}</p>
        <p class="reviews-card__date">{{ formattedDate }}</p>
      </div>
    </header>

    <div v-if="item.rating" class="reviews-card__stars" aria-label="Оценка">
      <span
        v-for="star in 5"
        :key="star"
        class="reviews-card__star"
        :class="{ 'is-active': star <= item.rating }"
      >★</span>
    </div>

    <div v-if="metaTags.length" class="reviews-card__tags">
      <span
        v-for="tag in metaTags"
        :key="tag.key"
        class="reviews-card__meta-tag"
        :class="'reviews-card__meta-tag--' + tag.kind"
      >{{ tag.label }}</span>
      <ReviewCategoryTag
        v-for="tag in categories"
        :key="'c-' + tag"
        :label="tag"
      />
    </div>
    <div v-else-if="categories.length" class="reviews-card__tags">
      <ReviewCategoryTag
        v-for="tag in categories"
        :key="tag"
        :label="tag"
      />
    </div>

    <p class="reviews-card__text">
      «{{ displayText }}»
    </p>
    <button
      v-if="isLong"
      type="button"
      class="reviews-card__more"
      @click="expanded = !expanded"
    >
      {{ expanded ? 'Свернуть' : 'Читать полностью' }}
    </button>
  </article>
</template>

<script>
import ReviewCategoryTag from '@/components/Reviews/ReviewCategoryTag.vue'
import { formatDoctorShortName } from '@/helpers/doctorName'

const MONTHS_RU = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
]

export default {
  name: 'ReviewsCard',
  components: { ReviewCategoryTag },
  props: {
    item: {
      type: Object,
      required: true,
    },
    featured: {
      type: Boolean,
      default: false,
    },
    previewLength: {
      type: Number,
      default: 220,
    },
  },
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    categories() {
      return Array.isArray(this.item.categories) ? this.item.categories : []
    },
    metaTags() {
      const tags = []
      if (this.item.departmentName) {
        tags.push({ key: 'dept', kind: 'dept', label: this.item.departmentName })
      }
      if (this.item.employeeName) {
        tags.push({
          key: 'emp',
          kind: 'doc',
          label: formatDoctorShortName(this.item.employeeName),
        })
      }
      return tags
    },
    initials() {
      const name = (this.item.name || '').trim()
      if (!name) return '?'
      const parts = name.split(/\s+/).filter(Boolean)
      if (parts.length === 1) {
        return parts[0].slice(0, 2).toUpperCase()
      }
      return (parts[0][0] + parts[1][0]).toUpperCase()
    },
    formattedDate() {
      const raw = this.item.date
      if (!raw) return ''
      const d = new Date(raw)
      if (Number.isNaN(d.getTime())) return raw
      return `${d.getDate()} ${MONTHS_RU[d.getMonth()]} ${d.getFullYear()}`
    },
    isLong() {
      return (this.item.review || '').length > this.previewLength
    },
    displayText() {
      const text = this.item.review || ''
      if (!this.isLong || this.expanded) return text
      return text.slice(0, this.previewLength).trim() + '…'
    },
  },
}
</script>
